import angular from 'angular';
import { Loader } from "@googlemaps/js-api-loader"
import {Inject, State, Module} from 'app/decorators';
import BaseRoute from 'app/routing';
import Modal from 'app/services/modals';
import Config from 'app/services/config';
import formValidate from 'app/directives/form.validation';
import FieldStore from 'app/stores/field';
import BlndTable from 'app/common/table';

import fieldsTpl from './fields.html';
import fieldModalTpl from './field.modal.html';
import { GOOGLE_API_KEY } from '../../constants';


@Inject('$scope', 'FieldStore', '$uibModalInstance', 'R', 'customer')
class FieldModalCtrl {
    constructor ($scope, FieldStore, $uibModalInstance, R, customer) {
        let self = this;
        this.R = R;
        this.$modal = $uibModalInstance;
        this.customer = customer;
        this.store = FieldStore;
        this.data = {
            customer: customer.id,
            geo: {},
        };
    }

    get title () {
        return '';
    }

    close () {
        this.$modal.dismiss();
    }

    onSubmit (data) {
        // get data from map and set to data object
        let lat = document.getElementById("geo_latitude").value
        let lng = document.getElementById("geo_longitude").value
        data.geo.latitude = lat ? lat : 0.0
        data.geo.longitude = lng ? lng : 0.0
        data.location = document.getElementById("location").value
    }

    submit () {
        let self = this;
        self.onSubmit(self.data).then(
            function(field){
                self.$modal.close(field);
            },
            function(resp) {
                self.errors = resp.data;
            },
        ).finally(() => self.loading = false);
    }

    prepareMap() {
        let self = this;
        const loader = new Loader({
            apiKey: GOOGLE_API_KEY,
            libraries: ["places"],
            version: "weekly",
        })
        loader.load().then(() => {
            var position = {
                lat: self.data.geo.latitude != 0 ? self.data.geo.latitude : 39.411136,
                lng: self.data.geo.longitude != 0 ? self.data.geo.longitude : -77.402671,
            }
            var lat = document.getElementById("geo_latitude");
            var lng = document.getElementById("geo_longitude");
            var location = document.getElementById("location");

            var map = new google.maps.Map(
                document.getElementById("map"),
                {
                    zoom: 8,
                    center: position,
                });

            var marker = new google.maps.Marker({
                position: position,
                map: map,
                label: self.location,
                draggable: true,
            });
            marker.addListener("dragend", () => {
                lat.value = marker.getPosition().lat().toFixed(6);
                lng.value = marker.getPosition().lng().toFixed(6);
                location.value = `(${lat.value}, ${lng.value})`
            });

            var autocomplete = new google.maps.places.Autocomplete(
                location,
                {
                    componentRestrictions: {
                        country: ["us"]
                    },
                });

            // update map and geo fields on place select
            autocomplete.addListener("place_changed", () => {
                var place = autocomplete.getPlace();
                if (!place.geometry) {
                    input.placeholder = "Enter a place";
                } else {
                    let new_lat = place.geometry.location.lat().toFixed(6);
                    let new_lng = place.geometry.location.lng().toFixed(6);
                    let latLng = new google.maps.LatLng(new_lat, new_lng)

                    map.setCenter(latLng)
                    marker.setPosition(latLng)
                    lat.value = latLng.lat();
                    lng.value = latLng.lng();
                }
            });
            // workaround for google submitting form on enter
            location.addEventListener("keydown", (e) => {
                if (e.key == "Enter") {
                    e.preventDefault();
                }
            })
        })
    }
}

class AddFieldCtrl extends FieldModalCtrl {
    constructor (...params) {
        "ngInject";
        super(...params);
        this.prepareMap();
        this.data.geo = {
            latitude: 40.394776,
            longitude: -78.31599,
        };
    }

    get title () {
        return `Add new destination`;
    }

    onSubmit(data) {
        super.onSubmit(data)
        return this.store.create(data);
    }
}

@Inject('$growl', 'field', 'Modal')
class EditFieldCtrl extends FieldModalCtrl {
    constructor ($growl, field, Modal, ...params) {
        super(...params);
        this.field = field;
        this.$growl = $growl;
        this.Modal = Modal;
        this.data = this.R.copy(field);
        this.map = {
            latitude: this.data.geo.latitude,
            longitude: this.data.geo.longitude,
        };
        this.prepareMap();
    }

    get title () {
        return `Edit destination ${this.field.title}`;
    }

    onSubmit(data) {
        super.onSubmit(data);
        let self = this;
        return data.put().then(function(){
            angular.extend(self.field, data);
        });
    }

    close () {
        return super.close();
    }

    openDeleteModal () {
        let self = this;
        let $Modal = self.Modal.openConfirmDelete({
            text: `Are you sure to delete ${self.field.title} ?`,
        });
        $Modal.wait.then(function(result){
            self.store.remove(self.field.id).then(function(){
                result.close();
                self.close()
                self.$growl.deleted();
            });
        });
    }
}

class FieldsCtrl {
    constructor($state, $growl, Modal, FieldStore, NgTableParams, $customer) {
        "ngInject";
        this.$growl = $growl;
        this.Modal = Modal;
        this.customer = $customer;
        this.store = FieldStore;
        this.$state = $state;
        this.params = {customer: this.customer.id};

        this.table = new BlndTable(NgTableParams, this.store, {
            params: this.params,
        });
        this.field = null;
    }

    refresh () {
        return this.table.refresh(this.params);
    }

    pickField (field) {
        this.field = field || null;
    }

    openAddModal () {
        let self = this;
        let $modal = this.Modal.open({
            template: fieldModalTpl,
            controller: AddFieldCtrl,
            resolve: {
                customer: () => this.customer,
            },
        });
        $modal.result.then(function (field) {
            field.new = true;
            self.store.list.unshift(field);
            self.pickField((field));
            self.$growl.added();
        });
    }

    openEditModal () {
        let self = this;
        let $modal = this.Modal.open({
            template: fieldModalTpl,
            controller: EditFieldCtrl,
            resolve: {
                customer: () => this.customer,
                field: () => this.field,
            },
        });
        $modal.result.then(function(){
            self.$growl.updated();
            self.refresh()
        });
    }
}


@Module({
    name: 'app.customers.fields',
    modules: [
        BaseRoute,
        Modal,
        Config,
        formValidate,
        FieldStore,
    ],
})
@State({
    name: 'r.in.top.customers.detail.fields',
    url: '/destinations',
    controllerProvider: function (Config) {
        "ngInject";
        return Config.isFeatureFlagActive('REACT_CUSTOMER_DETAIL', true)
            ? function () {}
            : FieldsCtrl;
    },
    templateProvider: function (Config) {
        "ngInject";
        return Config.isFeatureFlagActive('REACT_CUSTOMER_DETAIL', true)
            ? '<div style="display:none"></div>'
            : fieldsTpl;
    },
    resolve: {
    },
    ncyBreadcrumb: {
        label: 'Destinations',
    },
})
export default class States {}



// WEBPACK FOOTER //
// ./src/app/customers/fields/routing.js